/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Samples_TrackingInputs */

const en_samples_tracking = /** @type {(inputs: Samples_TrackingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tracking`)
};

const es_samples_tracking = /** @type {(inputs: Samples_TrackingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rastreo`)
};

/**
* | output |
* | --- |
* | "Tracking" |
*
* @param {Samples_TrackingInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const samples_tracking = /** @type {((inputs?: Samples_TrackingInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Samples_TrackingInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_samples_tracking(inputs)
	return es_samples_tracking(inputs)
});